import { useState } from "react";
import { CursorType } from "frontend/canvas-designer-new/cursor-type";
import {
  widgets_cardStackIcon,
  widgets_ganttChartIcon,
  widgets_orgChartIcon,
  widgets_dependencyMappingIcon,
} from "frontend/canvas-designer-new/sidebar/side-menu-items/side-menu-icons";
import PadInline from "../components/pad-inline";
import { ScrollWithFade } from "../components/scroll-with-fade";
import WidgetMenuItem from "../components/widgets-menu-item";
import { getPathPrefix } from "utils/getPathPrefix";
import styles from "../components/components.module.css";
import { useFeatureFlag } from "frontend/hooks/use-feature-flag/use-feature-flag";
import SyncedWidgetsSubSubMenu, { SubSubMenuType } from "./synced-widgets-sub-sub-menu";

export default function SyncedWidgetsSubMenu({
  onClick,
  onClickTemplate,
}: {
  onClick: (widget: CursorType) => void;
  onClickTemplate: (templateIdOrData: string | unknown) => void;
}) {
  const [subMenuType, setSubMenuType] = useState<SubSubMenuType | null>(null);
  const syncedWidgetsFlowEnabled = useFeatureFlag("cim-synced-widgets");

  if (subMenuType) {
    return (
      <SyncedWidgetsSubSubMenu
        subMenuType={subMenuType}
        onGoBack={() => setSubMenuType(null)}
        onComplete={onClickTemplate}
      />
    );
  }

  return (
    <>
      <PadInline>
        <header className={styles.headerStyle}>Synced Widgets</header>
        <div className={styles.subHeadingStyle}>Connect to a board and create a live two way sync</div>
      </PadInline>
      <ScrollWithFade>
        <WidgetMenuItem
          image={widgets_ganttChartIcon}
          title={
            <>
              <img
                height="8px"
                src={getPathPrefix("/images/monday-mini-logo.svg")}
                style={{ marginBlock: "auto" }}
                alt="monday-logo"
              />{" "}
              Gantt chart
            </>
          }
          subtitle="Plan your work using a gantt"
          onClick={() => (syncedWidgetsFlowEnabled ? setSubMenuType("gantt-chart") : onClickTemplate("2849"))}
        />
        <WidgetMenuItem
          image={widgets_orgChartIcon}
          title={
            <>
              <img
                height="8px"
                src={getPathPrefix("/images/monday-mini-logo.svg")}
                style={{ marginBlock: "auto" }}
                alt="monday-logo"
              />{" "}
              Org chart
            </>
          }
          subtitle="Visualize team structures"
          onClick={() => (syncedWidgetsFlowEnabled ? setSubMenuType("org-chart") : onClick(CursorType.mindmapOrgChart))}
        />
        <WidgetMenuItem
          image={widgets_cardStackIcon}
          title={
            <>
              <img
                height="8px"
                src={getPathPrefix("/images/monday-mini-logo.svg")}
                style={{ marginBlock: "auto" }}
                alt="monday-logo"
              />{" "}
              Synced card stack
            </>
          }
          subtitle="Sort, stack, and filter your tasks"
          onClick={() =>
            syncedWidgetsFlowEnabled ? setSubMenuType("card-stack") : onClick(CursorType.liveIntegration)
          }
        />

        <WidgetMenuItem
          image={widgets_dependencyMappingIcon}
          title={
            <>
              <img
                height="8px"
                src={getPathPrefix("/images/monday-mini-logo.svg")}
                style={{ marginBlock: "auto" }}
                alt="monday-logo"
              />{" "}
              Dependency mapping
            </>
          }
          subtitle="Show how tasks or systems link"
          onClick={() => setSubMenuType("dependency-mapping")}
        />
      </ScrollWithFade>
    </>
  );
}
